import React from 'react'

const SectionLayout = ({ className = '', bgClassName = '', children, ...props }) => {
  const section = (
    <section
      className={`mx-auto size-full max-w-[1920px] px-4 py-10 md:px-[72px] lg:py-16 xl:px-[156px] ${className}`}
      {...props}>
      {children}
    </section>
  )
  return bgClassName ? <div className={bgClassName}>{section}</div> : section
}

export default SectionLayout
